import '.ac{padding:16px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.en{gap:0px;}.ssr-plugin'
import '.z{flex:1;}.ssr-plugin'
import '.d8{min-width:240px;}.ssr-plugin'
import '.q{cursor:pointer;}.ssr-plugin'
import '.cd{width:32px;}.ssr-plugin'
import '.eo{height:32px;}.ssr-plugin'
import '.d4{margin-bottom:16px;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import React from 'react'
import { styled, type Style } from 'inlines'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { Icon, IconProps } from '../Icon/index.js'

type LinkCardProps = {
  title: string
  description: string
  icon?: IconProps['variant']
  style?: Style
  onClick?: () => void
}
export const LinkCard = ({
  title,
  description,
  icon,
  onClick,
  style,
}: LinkCardProps) => {
  return (
    <styled.div className="ac a i en z d8 q"
      style={{
        borderRadius: radius[20],
        border: `1px solid ${colors.neutral20Adjusted}`,
        '&:hover': {
          backgroundColor: colors.neutral10Adjusted,
        },
        ...style,
      }}
      onClick={onClick}
    >
      <div className="cd eo d4 a c b q"
        style={{
          borderRadius: radius[8],
          border: `1px solid ${colors.neutral20Adjusted}`,
          background: `linear-gradient(180deg, transparent 0%, ${colors.neutral5} 100%)`,
        }}
      >
        <Icon variant={icon} color="neutral60" />
      </div>
      <Text variant="display-medium">{title}</Text>
      <Text variant="display-regular" color="neutral60">
        {description}
      </Text>
    </styled.div>
  )
}
